
import BasePageView from "components/core/BasePageView/BasePageView";
import useDDPodFormLogic from "./useDDPodFormLogic";
import DDPodFormDesktop from "./DDPodFormDesktop";
import DDPodFormMobile from "./DDPodFormMobile";

const DDPodForm = () => {
    const vm = useDDPodFormLogic();

    return (
        <BasePageView
            DesktopView={DDPodFormDesktop}
            MobileView={DDPodFormMobile}
            viewProps={vm}
        />
    );
};

export default DDPodForm;
